// extracted by mini-css-extract-plugin
module.exports = {"Content":"Content_Content__3jdjW","Content__postQuestion":"Content_Content__postQuestion__2SZbh"};